import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { BottomNav } from './BottomNav';
import { NAV_ITEMS, filterByPermisos } from './navItems';

export function Layout() {
  const { session, logout, tiene } = useAuth();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const visibles = filterByPermisos(NAV_ITEMS, tiene);

  const sidebar = (
    <>
      <div className="px-5 py-3 border-b border-slate-800 flex items-center justify-between">
        <div>
          <div className="text-brand-400 text-xs font-semibold tracking-widest">AREPAS MAESTRO</div>
          <div className="text-xs text-slate-400 mt-0.5">Panel operativo</div>
        </div>
        <button
          type="button"
          onClick={() => setOpen(false)}
          className="md:hidden text-slate-300 hover:text-white text-2xl leading-none px-2 py-1"
          aria-label="Cerrar menú"
        >
          ×
        </button>
      </div>
      <nav className="flex-1 p-1.5 overflow-y-auto space-y-0.5">
        {visibles.map((i) => (
          <NavLink
            key={i.to}
            to={i.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition ${
                isActive
                  ? 'bg-brand-500 text-slate-900 font-semibold'
                  : 'text-slate-300 hover:bg-slate-800'
              }`
            }
          >
            <span className="text-base">{i.icon}</span>
            <span className="truncate">{i.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="p-2.5 border-t border-slate-800">
        <div className="text-[10px] uppercase tracking-wide text-slate-500">Conectado</div>
        <div className="text-sm font-medium truncate">{session?.usuario.nombre}</div>
        <div className="text-[11px] text-slate-500 truncate">{session?.usuario.email}</div>
        <div className="mt-1 flex flex-wrap gap-1">
          {session?.usuario.roles.map((r) => (
            <span key={r} className="pill bg-slate-800 text-slate-300">{r}</span>
          ))}
        </div>
        <button
          type="button"
          onClick={() => void logout()}
          className="mt-2 w-full btn-secondary !bg-slate-800 !border-slate-700 !text-slate-300 hover:!bg-slate-700 !py-1.5 !text-sm"
        >
          Cerrar sesión
        </button>
      </div>
    </>
  );

  return (
    <div className="flex flex-col md:flex-row h-full">
      <header className="md:hidden flex items-center justify-between bg-slate-900 text-slate-100 px-4 py-3 border-b border-slate-800 sticky top-0 z-20">
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="text-slate-200 hover:text-white p-2 -ml-2 tap"
          aria-label="Abrir menú"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        <div className="text-brand-400 text-[11px] font-semibold tracking-widest">AREPAS MAESTRO</div>
        <div className="w-10" />
      </header>

      {open && (
        <div
          className="md:hidden fixed inset-0 bg-black/50 z-40"
          onClick={() => setOpen(false)}
          aria-hidden
        />
      )}

      <aside
        className={`bg-slate-900 text-slate-100 flex flex-col z-50
          fixed md:static inset-y-0 left-0 w-72 max-w-[85vw]
          transform transition-transform duration-200 ease-out
          ${open ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 md:w-64`}
      >
        {sidebar}
      </aside>

      <main className="flex-1 overflow-y-auto bg-slate-50 min-w-0 pb-20 md:pb-0">
        <div className="max-w-7xl mx-auto p-3 sm:p-4 md:p-6">
          <Outlet />
        </div>
      </main>

      <BottomNav onOpenMenu={() => setOpen(true)} />
    </div>
  );
}
